import { render, staticRenderFns } from "./link-point-of-sale-step-2.vue?vue&type=template&id=5426dbd0&"
import script from "./link-point-of-sale-step-2.vue?vue&type=script&lang=js&"
export * from "./link-point-of-sale-step-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports